import SectionSlider from "../../sections/common/home-sections/slider";
import {useEffect} from "react";
import {loadScript} from "../../../globals/constants";
import TestimonialsPage from "../company/testimonials";
import HeaderMain from "../../sections/common/header";
import Footer from "../../sections/common/footer";

function HomePage() {
    useEffect(() => {
        loadScript("js/custom.js");
    });

    return (
        <div className="page-wraper">
            {<HeaderMain/>}
            <div className="page-content">
                <SectionSlider/>
                <TestimonialsPage/>
            </div>
            {<Footer/>}
            <button className="scroltop">
                <span className="fa fa-angle-up relative" id="btn-vibrate"></span>
            </button>
        </div>
    );
}

export default HomePage;
